export default __webpack_public_path__ + "static/media/coming_soon.ff73e1ca.svg";